/* jshint esnext: true */
import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Datepicker';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-datepicker-open', (event) => {
            $html.addClass('has-calendar-open');
        });

        this.$el.on(EVENT.CLICK, '.js-datepicker-close', (event) => {
            $html.removeClass('has-calendar-open');
        });
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
